<template>
  <b-modal
    id="invitation-modal"
    ref="inviteMemberModal"
    modal-class="invitation"
    title="Invite New Team Member"
    hide-footer
    size="md"
    @hidden="resetForm">
    <label
      class="col-form-label pt-0">
      Email
    </label>
    <b-form-group>
      <b-input
        v-model="email"
        v-validate.continue="'required|email'"
        type="email"
        data-vv-as="Email"
        data-vv-name="email"
        data-vv-validate-on="input"
        placeholder="user@email.com"
        autofocus/>
      <span
        v-if="validationErrors.email"
        class="validation-error clearfix">
        {{ validationErrors.email }}
      </span>
      <span
        v-if="errors.has('email')"
        class="validation-error">{{ errors.first('email') }}</span>
    </b-form-group>
    <label
      class="col-form-label pt-0">
      Role
    </label>
    <b-form-group>
      <b-select
        v-model="role"
        :options="roles"
        value-field="alias"
        text-field="name"
        placeholder="Role"/>
      <span
        v-if="validationErrors.role"
        class="validation-error">{{ validationErrors.role }}</span>
    </b-form-group>
    <label
      class="col-form-label pt-0">
      User will join following teams
    </label>
    <b-form-group>
      <b-check-group
        v-model="selectedTeams"
        class="selected-teams"
        stacked>
        <b-checkbox
          v-for="team in teams"
          :key="team.id"
          :value="team.id"
          :disabled="checkSelectedCount(team.id)">
          {{ team.name }}
        </b-checkbox>
      </b-check-group>
    </b-form-group>
    <span
      v-if="errorMessage"
      class="error-message">
      {{ errorMessage }}
    </span>
    <b-button
      :class="{loading: sending}"
      :disabled="sending || !canSubmit"
      class="btn-round btn-block mt-4 mb-4"
      @click="inviteUser">
      <span v-if="!sending">Send</span>
      <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import roles from '@/helpers/lists/roles';
import setValidationErrors from '@/helpers/validationErrors';

export default {
  name: 'MemberInviteModal',
  data() {
    return {
      roles,
      role: 'member',
      selectedTeams: [],
      email: '',
      sending: false,
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      teams: 'team/teamList',
      apiError: 'merchant/apiError',
    }),
    invitationSent: {
      get() {
        return this.$store.state.merchant.invitationSent;
      },
      set(val) {
        this.$store.state.merchant.invitationSent = val;
      },
    },
    canSubmit() {
      return (this.veeFields && this.veeFields.email) ? this.veeFields.email.valid : false;
    },
  },
  watch: {
    invitationSent(invited) {
      if (invited) {
        this.sending = false;
        this.$emit('invited', invited);

        this.hide();
      }
    },
    apiError(error) {
      this.sending = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  methods: {
    ...mapActions({
      inviteMember: 'merchant/inviteMember',
    }),
    setDefaultTeam() {
      this.selectedTeams.push(this.teams[0].id);
    },
    checkSelectedCount(teamId) {
      return (this.selectedTeams.length === 1 && this.selectedTeams.includes(teamId));
    },
    inviteUser() {
      this.sending = true;
      this.validationErrors = {};
      const payload = {
        merchant_id: this.$route.params.merchant_id,
        data: {
          email: this.email,
          role: this.role,
          team_ids: this.selectedTeams,
        },
      };
      this.inviteMember(payload);
    },
    show() {
      this.setDefaultTeam();
      this.$refs.inviteMemberModal.show();
    },
    hide() {
      this.invitationSent = false;
      this.$refs.inviteMemberModal.hide();
    },
    resetForm() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
  },
};
</script>
